//
//
//  Utils
//
//

export function isFunction(obj: any) {
    return !!(obj && obj.constructor && obj.call && obj.apply)
}

export function getMetaContent(name: string) {
    const metaHTML = document.querySelector(`meta[name="${name}"]`)
    if (metaHTML != null) {
        return metaHTML.getAttribute("content")
    }
}

export function generateColorFromString(text: string) {
    function hashCode(str: string) {
        let hash = 0;
        if (str.length === 0) return hash;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32-bit integer
        }
        return hash;
    }

    function intToRGB(i: number) {
        const c = (i & 0x00ffffff).toString(16).toUpperCase();
        return "#" + "00000".substring(0, 6 - c.length) + c;
    }

    const hash = hashCode(text);
    return intToRGB(hash);
}


export function formatDateTime(date: Date): string {
    // Get the individual components (day, month, year, hours, minutes)
    const day = date.getDate()
    const month = date.getMonth() + 1 // Months are zero-based, so add 1
    const year = date.getFullYear()
    const hours = date.getHours()
    const minutes = date.getMinutes()

    // Add leading zeros to ensure two-digit formatting
    const formattedDay = day < 10 ? '0' + day : day
    const formattedMonth = month < 10 ? '0' + month : month
    const formattedHours = hours < 10 ? '0' + hours : hours
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes

    // Create the formatted string
    return `${formattedDay}/${formattedMonth}/${year} @ ${formattedHours}:${formattedMinutes}`
}

export function formatDate(date: Date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // Adding 1 because getMonth() returns zero-based months
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export function getDayInterval(startDate: Date, endDate: Date): Date[] {
    const dates: Date[] = []
    const currentDate = new Date(startDate)

    while (currentDate <= endDate) {
        dates.push(new Date(currentDate))
        currentDate.setDate(currentDate.getDate() + 1)
    }
    return dates
}

export function getWeekInterval(startDate: Date, endDate: Date): Date[] {
    // Set the day of the week to Monday for the start date
    startDate = new Date(startDate)
    startDate.setHours(0, 0, 0, 0)
    startDate.setDate(startDate.getDate() + (1 - startDate.getDay() + 7) % 7)

    // Create an array to store the dates
    const dates: Date[] = []

    // Loop through the weeks and add dates to the array
    const currentDate = new Date(startDate)
    while (currentDate <= endDate) {
        dates.push(new Date(currentDate))
        currentDate.setDate(currentDate.getDate() + 7)
    }
    return dates
}

export function getMonthInterval(startDate: Date, endDate: Date): Date[] {
    // Set the day of the month to 1 for the start date
    startDate = new Date(startDate)
    startDate.setHours(0, 0, 0, 0)
    startDate.setDate(1)

    // Create an array to store the dates
    const dates: Date[] = []

    // Loop through the months and add dates to the array
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
        dates.push(new Date(currentDate))
        currentDate.setMonth(currentDate.getMonth() + 1)
        currentDate.setDate(1)
    }

    return dates
}


export function findObjectByValue(list: Array<any>, property: string, value: any): any | undefined {
    return list.find(obj => obj[property] === value);
}
